import { render, staticRenderFns } from "./ClicTabs.vue?vue&type=template&id=60c1b1be&"
import script from "./ClicTabs.vue?vue&type=script&lang=js&"
export * from "./ClicTabs.vue?vue&type=script&lang=js&"
import style0 from "./ClicTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports